// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ApiError, type PhoneNumberListe } from "../../api";
import { useListPhoneNumbers as useGetter } from "../hooks";
import { type QueryKey, useQuery, type UseQueryOptions } from "react-query";

export function useListPhoneNumbersQueryKey(): QueryKey {
  return ["api", "v1", "phonenumbers"];
}

export function useListPhoneNumbers(
  options: Omit<
    UseQueryOptions<PhoneNumberListe, ApiError>,
    "queryKey" | "queryFn"
  > = {}
): PhoneNumberListe {
  const getter = useGetter();
  return useQuery(useListPhoneNumbersQueryKey(), () => getter(), options).data!;
}
